export const EMOJI_ROWS = [
  ["👍", "❤️", "😂", "😮", "😢", "🙏", "🔥", "🎉"],
  ["😍", "🥰", "😊", "😎", "🤔", "😅", "🥲", "😭"],
  ["💯", "✨", "💪", "👏", "🫶", "🤝", "💀", "🫡"],
  ["😡", "🤯", "🥳", "😴", "🤮", "👀", "🫠", "💔"],
];
